import createImmutableSelector from 'lib/immutable/selector'
import { ILoading } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getLoading = (state: any): ILoading => state.get('loadingReducer')

export const loadingSelector = createImmutableSelector(getLoading, (loading) => loading)
